import $ from 'jquery'
import DateFilter from '@/components/date-filter';
import CancelInvoice from '@/components/caisse/factures/cancel-invoice'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import { cca_config } from '../../../plugins/cca-config';
import store_operation from "@/store/mods/caisse/operations"

export default {
    name: 'factures',
    components: {
        DateFilter, CancelInvoice
    },
    props: [],
    data() {
        return {
            vm_state: open_menu_state,
            is_loading: true,
            is_empty: false,
            is_load_error: false,

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            fields: [
                { key: 'ref', label: 'Référence' }, 'patient', 'date',
                { key: 'action', label: 'Action.s' }
            ],

            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,
            nom_clinique: '',
            liste_factures: [],
            selected_invoice: {},
            is_facture_assurance: 0
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.current_date_filter = data
            this.getListeFacture(data)
        },
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },

        selected_facture() {
            return this.$store.getters['selected_facture'];
        },
    },

    mounted() {
        this.$store.commit("SET_SELECTED_FACTURE", []);
        this.$store.commit("SET_SELECTED_PATIENT_ATTENTE", {});
        this.$store.commit("SET_PAYMENT_ACTION", '');
        this.nom_clinique = cca_config.NOM_CLINIQUE

        if (this.activeRole.nom == 'ROLE_CAISSIERE') {
            this.compte_id = 1 //  Caisse principale
        } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
            this.compte_id = 4 //  Caisse 1 (Infirmier)
        } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
            this.compte_id = 3 //  Comptabilité
        }

        this.checkRegisterCashStatus(this.compte_id)        // Function defined in util-mixins.js

        this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]

        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            this.v = 0;
            if (!$clicked.parents().hasClass("option-container")) {
                $(".option-box").removeClass("animate-fadeInRight");
                $(".option-box").addClass("animate-fadeOutRight");
                $(".option-box").fadeOut();
            }
        });

        Array.prototype.groupBy = function (key) {
            return this
                .reduce((hash, obj) => {
                    if (obj[key] === undefined) return hash;
                    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                }, {})
        };
    },

    methods: {
        /**
         * Open Menu Dropdown
         */
        openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        refreshInvoice() {
            this.getListeFacture(this.current_date_filter)
        },

        getListeFacture(data) {
            this.is_load_error = false
            this.is_loading = true
            store_operation.getListeFactures(data).then((response) => {
                this.liste_factures = response.data
                this.total_pages = response.last_page
                if (response.code && response.code == 503) {
                    this.is_load_error = true
                } else {
                    if (this.liste_factures.length > 0) {
                        this.is_empty = false
                    } else {
                        this.is_empty = true
                    }
                }

                this.is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.is_loading = false
            })
        },

        filterByDate(date) {
            this.selected_operations = []
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.getListeFacture(data)
        },

        viewDetail(facture) {
            const tmp_grouped_operations = facture.operations.groupBy('data_type')
            let grouped_operations = []

            for (const key in tmp_grouped_operations) {
                console.log("k --> ",key);

                if (key == 'chirurgie') {
                    const tmp_grouped_prestations = tmp_grouped_operations[key].groupBy('chirurgie')

                    for (const key_prest in tmp_grouped_prestations) {
                        // Calcul sous total
                        let sous_total = 0
                        let operations_len = tmp_grouped_prestations[key_prest].length
                        tmp_grouped_prestations[key_prest].forEach(operations => {
                            sous_total += operations.montant_paye
                        });

                        const tmp_group = {
                            data_type: key,
                            group_prestation: tmp_grouped_operations[key][0].group_prestation,
                            prestations: tmp_grouped_prestations[key_prest],
                            chirurgie: key_prest,
                            taux_assurance: tmp_grouped_operations[key][0].taux_assurance,
                            sous_total: sous_total,
                            can_show_subtotal: (operations_len > 1)?true:false
                        } 
                        grouped_operations.push(tmp_group) 
                    }
                } else {
                    if (key != 'acompte_impot') {
                        // Calcul sous total
                        let sous_total = 0
                        let operations_len = tmp_grouped_operations[key].length
                        tmp_grouped_operations[key].forEach(operations => {
                            let montant = (operations.data_type == 'apport_social')?-operations.montant_paye:operations.montant_paye
                            sous_total += montant
                        });
                        const tmp_group = {
                            data_type: key,
                            group_prestation: tmp_grouped_operations[key][0].group_prestation,
                            prestations: tmp_grouped_operations[key],
                            taux_assurance: tmp_grouped_operations[key][0].taux_assurance,
                            sous_total: sous_total,
                            can_show_subtotal: (operations_len > 1)?true:false
                        }
                        grouped_operations.push(tmp_group)
                    }
                    
                }
            }

            const selected_facture = {
                reference: facture.reference,
                rate_avg: facture.rate_avg,
                date: facture.date,
                patient_id: facture.patient_id,
                info_patient: facture.info_patient,
                caissiere: facture.user,
                operations: grouped_operations,
                mecef_info: facture,
                montant: facture.montant
            }

            this.$store.commit("SET_SELECTED_FACTURE", selected_facture);

            setTimeout(() => {
                this.$router.push({ path: '/factures/detail-facture' })
            }, 500);
        },

        setInvoiceToCancel(facture) {
            this.selected_invoice = {
                facture_id: facture.facture_id,
                reference: facture.reference,
                patient_id: facture.patient_id,
                patient: facture.info_patient.patient,
                is_facture_avoir: (facture.type_facture == 'FA' || facture.type_facture == 'EA')?1:0
            }

            setTimeout(() => {
                $('.cancel-invoice').modal('show')
            }, 500);
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.current_date_filter.page = this.currentPage
                this.getListeTicketCaisse(this.current_date_filter)
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.current_date_filter.page = this.currentPage
                this.getListeTicketCaisse(this.current_date_filter)
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.current_date_filter.page = this.currentPage
                this.getListeTicketCaisse(this.current_date_filter)
            }
        },
    }
}